// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__4JuNW","rotate":"Loader_rotate__lo6hj"};